import React from "react";
import tuncayLogo from "../assets/logo/tuncay.png";
import cardLogos from "../assets/card-logos.png";
import memleketSigorta from "../assets/logo/MemleketSigorta.png";
import EftalLogo from "./EftalLogo";
import { Link } from "react-router-dom";

export default function NoAuthFooter() {
  return (
    <footer className="mt-auto p-6 md:p-8 border-t border-gray-200/60 bg-white flex flex-col md:flex-row items-center justify-between gap-6 w-full px-4 sm:px-6 lg:px-8">
      <div className="flex items-center justify-center gap-8 sm:gap-14">
        <div className="flex items-center justify-center">
          <img
            src={memleketSigorta}
            alt="Memleket Sigorta"
            className="h-12 mb-5 w-auto object-contain"
          />
        </div>
        <div className="flex items-center justify-center">
          <EftalLogo width={100} height={32} />
        </div>
      </div>

      <div className="flex items-center justify-center gap-8 sm:gap-14">
        <div className="flex items-center justify-center">
          <img
            src={cardLogos}
            alt="Memleket Sigorta"
            className=" mb-5 object-contain"
            height={30}
          />
        </div>
      </div>

      <div className="flex flex-wrap items-center justify-center gap-x-4 gap-y-2 text-xs font-medium text-gray-400">
        <Link
          to="/privacy-policy"
          className="hover:text-[#1e3a8a] transition-colors"
        >
          Gizlilik Politikası
        </Link>
        <span className="text-gray-200 hidden sm:inline">|</span>
        <Link to="/kvkk" className="hover:text-[#1e3a8a] transition-colors">
          KVKK Aydınlatma Metni
        </Link>
        <span className="text-gray-200 hidden sm:inline">|</span>
        <Link to="/cookies" className="hover:text-[#1e3a8a] transition-colors">
          Çerez Politikası
        </Link>
      </div>
    </footer>
  );
}
